import type { HTMLAttributes } from 'react';
import { cn } from '../../lib/cn.ts';

/** A placeholder with the final layout size, so nothing jumps when the data arrives. */
export function Skeleton({ className, ...props }: HTMLAttributes<HTMLDivElement>) {
  return (
    <div
      aria-hidden="true"
      className={cn('animate-pulse rounded-md bg-muted', className)}
      {...props}
    />
  );
}
